// Open external links in new tab/window
export function handleExternalLinks() {
    jQuery('a').each(function() {
        var a = new RegExp('/' + window.location.host + '/');
        if (!a.test(this.href)) {
            jQuery(this).attr('target', '_blank'); // Set target attribute to '_blank'
        }
    });
}
